import sortBy from 'lodash/sortBy';
import { type OpenApiSchemaMediaItem } from '../../../api/schema';

export function getProductImageSources(image: Pick<OpenApiSchemaMediaItem, 'file_path' | 'sizes'>): [string, number][] {
    const originalSource = image.file_path;
    const sources: [string, number][] = (image.sizes || []).map((size) => [
        size.alias ? originalSource.replace(/orig$/, size.alias) : originalSource,
        size.width ?? Number.MAX_SAFE_INTEGER,
    ]);

    return sources.length ? sortBy(sources, '1') : [[originalSource, Number.MAX_SAFE_INTEGER]];
}
